@use "../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../styles/Colors.scss" as Colors;

.contact-billing-dropdown {
	& + & {
		width: max-content;
		padding-bottom: Constants.$val-spacing-m;
		position: relative !important;
		overflow: visible;
		z-index: auto !important;
	}
}

.status-cell {
	display: flex;
	align-items: center;

	.status-unknown{
		color: Colors.$col-orange;
	}

	.status-opened{
		color: Colors.$col-green;
	}

	.status-error {
		color: Colors.$col-canceledRed;
	}

	.status-notSent {
		color: Colors.$col-design-grey10;
	}

	.status-queued {
		color: Colors.$col-orange;
	}

	.status-unread {
		color: Colors.$col-orangeBorder;
	}

	[class="icon-email"] {
		user-select: text;
		font-size: Constants.$val-fontSizeBig;
	}

	.email-status-text{
		margin-left: Constants.$val-inputPadding-tb;
	}
}

.info-message{
	font-style: italic;
	color: Colors.$col-design-gray5;
	margin-bottom: Constants.$val-spacing-m;
}
